import * as yup from "yup";
import { CompanyReservationCode } from "../../../../model/CompanyReservationCode";

const mandatoryMessage = "Obligatoriskt";

const getEditB2bCompanyCustomProductsValidationSchema = (applicableCodes?: CompanyReservationCode[]) => {
    return yup
        .object()
        .shape(
            {
                "name": yup
                    .string()
                    .required(mandatoryMessage),
                "description": yup
                    .string()
                    .notRequired(),
                "codeHolderId": yup
                    .string()
                    .test({
                        message: () => "Angiven reservation/kod är inte längre giltig",
                        test(value) {
                            return !value || applicableCodes?.some(x => x.codeHolderId === value);
                        },
                    })
                    .notRequired()
            }
        );
};

export default getEditB2bCompanyCustomProductsValidationSchema;
